import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NguoiYeuCauService {

  constructor(private httpClient: HttpClient) { }

  findNYC(findValue: string, limit: number, pageNumber: number): any {
    return this.httpClient.get('/api/Thongtinnguoiyeucaucongchungs/GetNYC?searchValue=' + findValue + '&pageSize=' + limit + '&pageNumber=' + pageNumber);
  }

  getNYCById(id: number): any {
    return this.httpClient.get('/api/Thongtinnguoiyeucaucongchungs/' + id);
  }

  update(id: number, dataPost: any): any {
    return this.httpClient.put('/api/Thongtinnguoiyeucaucongchungs/' + id, dataPost);
  }

  add(data: any): any {
    return this.httpClient.post('/api/Thongtinnguoiyeucaucongchungs/', data);
  }

  delete(id: number): any {
    return this.httpClient.delete('/api/Thongtinnguoiyeucaucongchungs/' + id);
  }

  count(searchValue: string) {
    return this.httpClient.get('/api/Thongtinnguoiyeucaucongchungs/Count?searchValue=' + searchValue);
  }
}
